import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    contents: String,
    successMessage: String,
    successDuration: {
      type: Number,
      default: 2000,
    },
  };

  declare successDurationValue: number;
  declare successMessageValue: string;
  declare contentsValue: string;

  timeout?: number;
  originalContent?: string;

  connect(): void {
    this.originalContent = this.element.innerHTML;
  }

  async copy(event: Event): Promise<void> {
    event.preventDefault();
    await navigator.clipboard.writeText(this.contentsValue);
    this.copied();
  }

  copied(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.element.innerHTML = this.successMessageValue;

    this.timeout = window.setTimeout(() => {
      this.element.innerHTML = this.originalContent ?? "";
    }, this.successDurationValue);
  }
}
